<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center ">
            <img src="assets/images/logos/ic.svg" style="width: 70%;">
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12 form-horizontal">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="bg-registro-light" style="padding-top: 10px;padding-bottom: 10px; overflow: hidden;">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">

                            <p [hidden]="step1Ok" class="lead text-center mobile-content-hide">Ingresa tu correo
                                electrónico para recuperar tu contraseña.</p>
                            <p [hidden]="!step1Ok" class="lead text-center mobile-content-hide">Introduce el código que
                                enviamos a tu correo electrónico.</p>

                            <p [hidden]="step1Ok" class="lead text-left mobile-content-show">Introduce el código que
                                enviamos a tu correo electrónico.</p>
                            <p [hidden]="!step1Ok" class="lead text-left mobile-content-show">Ingresa tu correo
                                electrónico para recuperar tu contraseña.</p>

                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>

                <div [formGroup]="step1" [hidden]="step1Ok">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label class="control-label">Correo electrónico</label>

                            <input name="txtUsername" type="email" class="form-control input-md placeholder-input"
                                formControlName="email" placeholder="Ingresa tu correo electrónico" autocomplete="off"
                                required />

                            <div *ngIf="step1.get('email').invalid && (step1.get('email').dirty)">
                                <div [hidden]="!step1.get('email').errors['required']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> Debes ingresar el correo electrónico.
                                </div>
                                <div [hidden]="!step1.get('email').errors['email']"
                                    class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> El dato ingresado debe ser un correo
                                    electrónico.
                                </div>
                            </div>
                            <div [hidden]="hiddenUserNotExist"
                                class="alert alert-danger animated fadeIn f12 p5top p5bottom m10bottom">
                                <i class="fa fa-exclamation-triangle"></i> El correo electrónico no existe.
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row align-items-center">
                        <div class="form-group col-lg-12">
                            <re-captcha #captchaRef="reCaptcha" name="captcha" formControlName="captcha"></re-captcha>
                        </div>
                    </div>
                </div>

                <div [formGroup]="step2" [hidden]="!step1Ok">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Código <small class="text-muted f11"><em></em></small></label>
                            <input name="verificationcode" type="number" class="form-control input-md placeholder-input"
                                formControlName="verificationcode" placeholder="123456" autocomplete="off" required />
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Nueva contraseña <small class="text-muted f11"><em>(Debe contener mínimo 6
                                        caracteres)</em></small></label>
                            <input #xPass name="password" formControlName="password" type="password"
                                placeholder="Vuelve a ingresar tu contraseña"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                minlength="6" required
                                [ngClass]="{'is-valid': step2.get('password').valid, 'is-invalid':step2.get('password').invalid && (step2.get('password').dirty) }">
                            <span (click)="xPass.type = xPass.type == 'password' ? 'text' : 'password'"
                                class="{{xPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Confirmar contraseña</label>
                            <input #xConfPass name="confirmpassword" formControlName="confirmpassword" type="password"
                                placeholder="Vuelve a ingresar tu contraseña"
                                class="form-control input-md placeholder-input input-form-usuario-registro"
                                minlength="6" required
                                [ngClass]="{'is-valid': step2.get('confirmpassword').valid, 'is-invalid':step2.get('confirmpassword').invalid && (step2.get('confirmpassword').dirty) }">
                            <span (click)="xConfPass.type = xConfPass.type == 'password' ? 'text' : 'password'"
                                class="{{xConfPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>

                <div [hidden]="!step1Ok" class="col-lg-12 mobile-content-show">
                    <div class="col-lg-2"></div>
                    <div class="form-group col-lg-8">
                        <button [disabled]="!step2.valid" (click)="onResetPassword()" class="col-xs-6"
                            class="btn btn-lg btn-orange btn-block m0top">Crear contraseña</button>
                    </div>
                    <div class="col-lg-2"></div>
                </div>

                <div [hidden]="step1Ok" class="col-lg-12 mobile-content-show">
                    <div class="col-lg-2"></div>
                    <div class="col-lg-8">
                        <button [disabled]="!step1.valid" (click)="onSendPasswordRecover()"
                            class="btn btn-lg btn-orange btn-block m0top">Enviar</button>
                    </div>
                    <div class="col-lg-2"></div>
                </div>
            </div>

            <div class="col-lg-12">
                <br />
            </div>

            <div class="col-lg-12">
                <div class="col-lg-6">
                    <a (click)="volver()" class="btn btn-lg btn-atras btn-block m0top">Volver al login</a>
                </div>
                <div class="col-lg-6 mobile-content-hide" [hidden]="step1Ok">
                    <button [disabled]="!step1.valid" (click)="onSendPasswordRecover()"
                        class="btn btn-lg btn-orange btn-block m0top">Enviar</button>
                </div>
                <div [hidden]="!step1Ok" class="col-lg-6 mobile-content-hide">
                    <button [disabled]="!step2.valid" (click)="onResetPassword()" type="submit"
                        class="btn btn-lg btn-orange btn-block m0top">Crear
                        contraseña</button>
                </div>
            </div>

        </div>
        <div class="col-lg-3"></div>
    </div>
</div>